import { Link } from 'react-router-dom';

export function WorkInProgressPage({ pageLabel }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white px-8 py-10 text-center shadow-sm">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-amber-700">
          Work is under progress
        </p>
        <h1 className="mt-3 text-2xl font-semibold tracking-tight text-slate-900">
          {pageLabel || 'This page'} is temporarily unavailable
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          We’re updating this section of the workspace. Please check back shortly or continue
          with another page.
        </p>
        <Link
          to="/admin/dashboard"
          className="mt-6 inline-flex min-h-10 items-center justify-center rounded-lg bg-slate-900 px-4 text-sm font-semibold text-white transition hover:bg-slate-800"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}

export default WorkInProgressPage;
